define('core/views/AlertView',[
    'backbone',

    'core/templates/alert',
], function (
    Backbone,

    alertTemplate
) {
    'use strict';

    var AlertView = Backbone.View.extend({
        className: 'alert',

        events: {
            'click [data-action=dismiss]': 'dismiss',
        },

        // Options:
        //   message {string} - the message to display (required)
        //   safe {boolean} - if true, template doesn't escape message
        //   type {string} - one of: error, info, success, warn
        initialize: function (options) {
            this.options = options;

            this.message = options.message;
            this.safe = options.safe;
            this.type = options.type;
        },

        render: function () {
            var $el = this.$el;

            $el.html(alertTemplate({
                message: this.message,
                safe: this.safe,
                icon: this.type === 'error',
            }));

            // reset classes
            $el.attr('class', this.className);

            if (this.type)
                $el.addClass(this.type);

            return this;
        },

        dismiss: function (evt) {
            if (evt && evt.preventDefault)
                evt.preventDefault();

            this.remove();
            this.trigger('dismiss');
        },
    });

    return AlertView;
});

